export default __webpack_public_path__ + "static/media/confirm.3c54ab3c.svg";